module.exports = __webpack_public_path__ + "img/product-shoes.c684afd5.jpg";